<al-auth-flow-modal></al-auth-flow-modal>

<div class="app-container">
    <div class="form-group">
        <div class="row">
            <ng-container *ngFor="let param of appParams.parameters">
                <!-- Primary parameters with no underlying elements -->
                <div class="col-lg-6" *ngIf="!param.underlyingElements || !formGroup.get(param?.fieldName)?.value">
                    <app-link-edit-application-login-fields [param]="param" [formGroup]="formGroup"></app-link-edit-application-login-fields>
                </div>

                <!-- Parameters with underlying elements -->
                <ng-container *ngIf="param.underlyingElements && formGroup.get(param?.fieldName)?.value">
                    <!-- Main parameter without col-lg-6 -->
                    <div class="col-lg-6">
                        <app-link-edit-application-login-fields [param]="param" [formGroup]="formGroup"></app-link-edit-application-login-fields>
                    </div>
                    <!-- Nested underlying elements with col-lg-6 -->
                    <ng-container *ngFor="let element of param.underlyingElements">
                        <div class="col-lg-6">
                            <app-link-edit-application-login-fields [param]="element" [formGroup]="formGroup"></app-link-edit-application-login-fields>
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container>

        </div>
    </div>
    <div *ngIf="!testerMode" class="row-fix">
        <button [disabled]="disabledLoginBtnObservable | async" class="btn btn-success btn-sm test-button" (click)="savebtn()">Save</button>
        <ng-container *ngIf="doesLoginHaveId$ | async as doesHaveId">
            <button [disabled]="disabledLoginBtnObservable | async" class="btn btn-info btn-sm test-button" (click)="authorizebtn()" [hidden]="!appParams.oAuth">Authenticate</button>
            <button *ngIf="doesHaveId == true" [disabled]="disabledLoginBtnObservable | async" class="btn btn-primary btn-sm test-button" (click)="testbtn()">Test</button>
        </ng-container>

        <ng-container *ngIf="loginValiditySubject | async as validity">
            <span class="form-label validated">

                <ng-container [ngSwitch]="validity">
                    <!-- the same view can be shown in more than one case -->
                    <ng-container *ngSwitchCase="applicationLoginStatus.undefined"></ng-container>
                    <ng-container *ngSwitchCase="applicationLoginStatus.invalid">Unable to authenticate </ng-container>
                    <ng-container *ngSwitchCase="applicationLoginStatus.valid">Login valid </ng-container>
                    <ng-container *ngSwitchCase="applicationLoginStatus.pending">Checking </ng-container>
                    <!--default case when there are no matches -->
                </ng-container>

                <i class="far" [ngClass]="{
            'text-danger': validity === applicationLoginStatus.undefined,
            'fa-exclamation-circle text-danger': validity === applicationLoginStatus.invalid,
            'fa-check-circle text-success': validity === applicationLoginStatus.valid,
            'fa-spinner fa-pulse': validity === applicationLoginStatus.pending
        }"></i>
            </span>

        </ng-container>
    </div>
    <div *ngIf="testerMode">
        <button [disabled]="disabledLoginBtnObservable | async" class="btn btn-info btn-sm" (click)="retrieveCredentials()">Authenticate</button>
        <dx-check-box style="padding-left: 10px;" [disabled]="disabledLoginBtnObservable | async" [(value)]="isEncrypted" text="Encrypted"></dx-check-box>
    </div>
</div>
